"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELDS_MODAL_CLOSE = exports.FIELDS_MODAL_OPEN = void 0;
const reportsModalNamespace = '@sok/reports/modal';
exports.FIELDS_MODAL_OPEN = `${reportsModalNamespace}/FIELDS_MODAL_OPEN`;
exports.FIELDS_MODAL_CLOSE = `${reportsModalNamespace}/FIELDS_MODAL_CLOSE`;
//# sourceMappingURL=fieldsModal.js.map